export const UPDATE_COMPLETE = 'UPDATE_COMPLETE';
export const UPDATE_ERROR = 'UPDATE_ERROR';
export const UPDATE_LOADING = 'UPDATE_LOADING';

// signin
export const UPDATE_SIGNIN = 'UPDATE_SIGNIN';
export const UPDATE_USERS_NOTIFICATION_NEW = 'UPDATE_USERS_NOTIFICATION_NEW';

// users
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const UPDATE_USERS = 'UPDATE_USERS';

// common
export const UPDATE_LANGUAGE = 'UPDATE_LANGUAGE';
export const UPDATE_LANGUAGES = 'UPDATE_LANGUAGES';
export const UPDATE_COMMON_ERROR = 'UPDATE_COMMON_ERROR';
export const UPDATE_TOGGLE_MENU = 'UPDATE_TOGGLE_MENU';

// chat
export const UPDATE_CHAT_TOTALS = 'UPDATE_CHAT_TOTALS';
export const UPDATE_CHAT_TOTALS_RELOAD = 'UPDATE_CHAT_TOTALS_RELOAD';
export const UPDATE_CHAT_FILTER = 'UPDATE_CHAT_FILTER';
export const UPDATE_CHAT_LIST = 'UPDATE_CHAT_LIST';
export const UPDATE_CHAT_MESSAGES = 'UPDATE_CHAT_MESSAGES';
export const UPDATE_CHAT_MESSAGES_LOADING = 'UPDATE_CHAT_MESSAGES_LOADING';
export const UPDATE_CHAT_CLIENT = 'UPDATE_CHAT_CLIENT';
export const UPDATE_CHAT_CLIENT_RELOAD = 'UPDATE_CHAT_CLIENT_RELOAD';
export const UPDATE_CHAT_CLIENT_DATA = 'UPDATE_CHAT_CLIENT_DATA';
export const UPDATE_CHAT_CLIENT_REPORTS = 'UPDATE_CHAT_CLIENT_REPORTS';
export const UPDATE_CHAT_CLIENT_REPORT = 'UPDATE_CHAT_CLIENT_REPORT';
export const UPDATE_CHAT_CLIENT_REPORT_ID = 'UPDATE_CHAT_CLIENT_REPORT_ID';
export const UPDATE_CHAT_CLIENT_NOTICE_ADD = 'UPDATE_CHAT_CLIENT_NOTICE_ADD';
export const UPDATE_CHAT_CLIENT_NOTICE_REMOVE = 'UPDATE_CHAT_CLIENT_NOTICE_REMOVE';
export const UPDATE_CHAT_ACTIVE = 'UPDATE_CHAT_ACTIVE';
export const UPDATE_CHAT_ERROR = 'UPDATE_CHAT_ERROR';
export const UPDATE_CHAT_LOADING = 'UPDATE_CHAT_LOADING';
export const UPDATE_CHAT_NEW_MESSAGE = 'UPDATE_CHAT_NEW_MESSAGE';
export const UPDATE_CHAT_REMOVE_MESSAGE = 'UPDATE_CHAT_REMOVE_MESSAGE';
export const UPDATE_CHAT_READ_MESSAGE = 'UPDATE_CHAT_READ_MESSAGE';
export const UPDATE_CHAT_ITEM_FAVORITE = 'UPDATE_CHAT_ITEM_FAVORITE';
export const UPDATE_CHAT_ITEM_NEW = 'UPDATE_CHAT_ITEM_NEW';
export const UPDATE_CHAT_REMINDER_EDIT = 'UPDATE_CHAT_REMINDER_EDIT';
export const UPDATE_CHAT_REMINDER_NEW = 'UPDATE_CHAT_REMINDER_NEW';
export const UPDATE_CHAT_REMINDER_REMOVE = 'UPDATE_CHAT_REMINDER_REMOVE';
export const UPDATE_CHAT_EDIT_MESSAGE = 'UPDATE_CHAT_EDIT_MESSAGE';
export const UPDATE_CHAT_CHANGED_MESSAGE = 'UPDATE_CHAT_CHANGED_MESSAGE';
export const UPDATE_CHAT_REPLY_MESSAGE = 'UPDATE_CHAT_REPLY_MESSAGE';
export const UPDATE_CHAT_ALERT = 'UPDATE_CHAT_ALERT';
export const UPDATE_CHAT_SETTINGS = 'UPDATE_CHAT_SETTINGS';
export const UPDATE_CHAT_UNANSWERED = 'UPDATE_CHAT_UNANSWERED';
export const UPDATE_CHAT_CLIENT_ID = 'UPDATE_CHAT_CLIENT_ID';
export const UPDATE_CHAT_CLIENT_CURATOR_DATA = 'UPDATE_CHAT_CLIENT_CURATOR_DATA';
export const UPDATE_CHAT_CLIENT_UNBAN_CHAT_MEMBER = 'UPDATE_CHAT_CLIENT_UNBAN_CHAT_MEMBER';
export const UPDATE_PAGE = 'UPDATE_PAGE';
export const UPDATE_CHAT_CLEAR = 'UPDATE_CHAT_CLEAR';
export const UPDATE_CHAT_AI_BATCH = 'UPDATE_CHAT_AI_BATCH';
export const UPDATE_CHAT_AI_BATCH_CLEAR = 'UPDATE_CHAT_AI_BATCH_CLEAR';
export const UPDATE_CHAT_AI_CARD_EDIT = 'UPDATE_CHAT_AI_CARD_EDIT';

// The new AI design (Design3) is the default. ?ui switches back to the OLD interface
// (?ui=0 forces the new one back), and the choice is persisted in localStorage.
// Computed once per page load: this is called while rendering every message, and doing
// URLSearchParams + a synchronous localStorage access per call janks a long feed.
let newAiUiCache = null;
export const newAiUiEnabled = () => {
  if (newAiUiCache !== null) {
    return newAiUiCache;
  }
  try {
    const p = new URLSearchParams(window.location.search);
    if (p.has('ui')) {
      // ?ui -> old interface, ?ui=0 -> new interface
      const oldWanted = p.get('ui') !== '0';
      localStorage.setItem('dc_ai_ui', oldWanted ? 'old' : 'new');
      newAiUiCache = !oldWanted;
    } else {
      // new UI is the default; only an explicit stored 'old' opts out
      newAiUiCache = localStorage.getItem('dc_ai_ui') !== 'old';
    }
  } catch (e) {
    newAiUiCache = true;
  }
  return newAiUiCache;
};

// form values marking the AI origin of a message in POST /auth/message
export const aiOriginApproved = 'approved';
export const aiOriginEdited = 'edited';
// Review statuses for gamma (POST /auth/ai/review). Gamma has no dedicated "edited"
// status, so an edited suggestion is reported as approved — the edit itself is recorded
// on our side via ai_origin=edited on the message.
export const aiReviewApproved = 'approved';
export const aiReviewDeclined = 'declined';
// auto comments (gamma requires a comment when status is declined)
export const aiDeclineAutoComment = 'Отклонено куратором из чата';
export const aiSelfAnswerComment = 'Куратор ответил сам, подсказка не использована';
// ai_status values on delivered (direction 2) messages
export const aiStatusSentApproved = 'S';
export const aiStatusSentEdited = 'E';
export const aiStatusSentAuto = 'T';
export const isAiCreated = (msg) => !!(msg && (msg.ai_status === aiStatusSentApproved || msg.ai_status === aiStatusSentEdited || msg.ai_status === aiStatusSentAuto));
export const aiCreatedTitle = (msg) => {
  switch (msg && msg.ai_status) {
    case aiStatusSentAuto: return 'Отправлено AI автоматически';
    case aiStatusSentApproved: return 'Ответ AI, одобрен куратором';
    case aiStatusSentEdited: return 'Ответ AI, отредактирован куратором';
    default: return '';
  }
};

// AI confidence level from pred_score/pred_label of last-batch (drives the card color/label).
// Green = the model would auto-approve (pred_label) or the score is high; yellow mid; red low.
export const aiConfidenceLevel = (batch) => {
  if (!batch) return null;
  const s = typeof batch.pred_score === 'number' ? batch.pred_score : null;
  // pred_label is checked before the score: gamma may send the label with no number, and
  // that is the most confident case — showing it as a grey "pending" misleads the curator
  if (batch.pred_label === 'auto_approve') return 'high';
  if (s === null) return 'pending';
  if (s >= 0.85) return 'high';
  if (s >= 0.6) return 'mid';
  return 'low';
};
export const aiConfidencePercent = (batch) => {
  const s = batch && typeof batch.pred_score === 'number' ? batch.pred_score : null;
  return s === null ? null : Math.round(s * 100);
};
export const aiConfidenceLabel = (level) => {
  switch (level) {
    case 'high': return 'Высокая уверенность';
    case 'mid': return 'Средняя уверенность';
    case 'low': return 'Низкая уверенность';
    default: return 'Оценивается…';
  }
};

// websockets
export const SOCKETS_CONNECTING = 'SOCKETS_CONNECTING';
export const SOCKETS_ERR = "SOCKETS_ERR";
export const TYPE_MSG_PING = "ping";
export const TYPE_MSG_NEW_MESSAGE = 'new_msg';
export const TYPE_MSG_EDIT_MESSAGE = 'edit_msg';
export const TYPE_MSG_NEW_CHAT = 'new_chat';
export const TYPE_MSG_NEW_REMIND = 'new_remind';
export const TYPE_MSG_CURATOR_CHANGED = 'curator_changed';
export const TYPE_MSG_MESSAGES_ANSWERED = 'messages_answered';
export const TYPE_MSG_GET_CHAT_MEMBER = 'get_chat_member';

// Учётка поддержки: на неё записаны переписки, которые ведёт техспециалист.
// В бэкенде тот же идентификатор известен как ClientEmpty — «куратора нет,
// клиенткой занимается техподдержка», и в канале DiChat её сообщения уходят в
// отдельную комнату «Поддержка ВесБаланс».
export const SUPPORT_USER_ID = 'c3e51184-ba83-443f-b1bd-4100ff055c8c';

const cfg = {path: '', base_url: '', public_url: '', socket_url: '', recaptcha: '6LeeNf4UAAAAAHKEdQuO9SkxE5exvC0_IAtM6_ea', is_desktop: false, is_win: null};
export default cfg;

export function handleResponse(response) {
    return new Promise((resolve, reject) => {
        if (response.status === 200) {
            return resolve(response.json());
        } else if (response.status === 401) {
          window.location = '/login';
          return reject(new Error('Unauthorized'));
        }
        response.text().then((txt) => {
            if (txt.trim()) {
                return reject(new Error(txt.trim()));
            }
            return reject(formatStatusError(response.status));
        }).catch((e) => {
            // reading the body can fail (aborted request) — without this the inner promise
            // rejects unhandled and the outer promise never settles. The original error is
            // passed through: callers filter cancellations by err.name === 'AbortError'.
            return reject(e);
        });
    });
}

export function formatStatusError(status) {
    switch (status) {
        case 403:
            return new Error('Access denied!');
        case 404:
            return new Error('Request URI is not found!');
        default:
            return new Error('Something goes wrong! Please try again.');
    }
}

// error formatting function
export function formatErrors(errors) {
  let err = '';
  for (const i of errors) {
    switch (i) {
      case 'error_other':
        err += 'Something goes wrong! Please try again.';
        break;
      case 'used:email':
        err += 'The email address is already used by another user';
        break;
      case 'empty:name':
        err += 'Please specify name';
        break;
      case 'invalid:form':
        err += 'The form is invalid! Please, check the fields and try again.';
        break;
      case 'wrong:auth':
        err += 'Wrong e-mail or password!';
        break;
      case 'empty:password':
        err += 'Empty password.';
        break;
      case 'wrong:user':
        err += 'Your session expired';
        break;
      case 'limit:not_email_confirm':
        err += 'Your e-mail is not confirmed';
        break;
      case 'wrong:email':
        err += 'E-mail not found';
        break;
      case 'error:not_found':
        err += 'Не найдено';
        break;
      case 'error:empty_code':
        err += 'Пустой код';
        break;

      default:
        err += i;
        break;
    }
  }
  return err
}

export const validateEmail = (value) => {
    const email_filter = /^[\w-]+(\.[\w-]+)*@([a-z0-9-]+(\.[a-z0-9-]+)*?\.[a-z]{2,6}|(\d{1,3}\.){3}\d{1,3})(:\d{4})?$/;
    return email_filter.test(value);
};

export const userPrintName = (i) => {
  let name= '';
  if (i.last_name) {
    name += i.last_name;
  }
  if (i.first_name) {
    if (name) {
      name += ' ' + i.first_name.trim().substring(0, 1) + '.';
      if (i.patronymic_name) {
        name += i.patronymic_name.trim().substring(0, 1) + '.';
      }
    } else {
      name += i.first_name + (i.patronymic_name ? ' ' + i.patronymic_name : '');
    }
  }
  if (!name) {
    name = i.email;
  }
  return name;
};

// user roles
export const roleCurator = 1;
export const roleAdmin = 2;
export const roleTechnicalSpecialist = 3;
export const roleChiefNutritionist = 4;
export const roleTrainee = 5;
export const roleNames = ['Куратор', 'Админ', 'Технический специалист', 'Главный диетолог', 'Стажер'];
export const emptyUser = '00000000-0000-0000-0000-000000000000';


// user allergies
export const userAllergies = ['Молоко', 'Орехи', 'Яйца', 'Бобовые', 'Злаки', 'Цитрусовые'];
// user diseases
export const userDiseases = [
'Нефролитиаз',
'Удаление щитовидной железы',
'Гепатоз',
'Дуоденит',
'Инсулинорезистентность',
'Холецистэктомия',
'Язва (в ремиссии)',
'Сахарный диабет',
'Гипотиреоз',
'Панкреатит',
'Пиелонефрит',
'Мочекаменная болезнь (МКБ)',
'Холецистит',
'Гастрит',
'Гипертония',
'Язвенный колит',
'Грудное кормление',
'Желчнокаменная болезнь',
'ДЖВП (дискинезия желчевыводящих путей)',

'Колиты',
'Гипотония',
'Варикоз',
'Запоры',
'Поносы',
'Метеоризм',
'Изжога',
'Повышенный аппетит',
'Бессонница',
'Нефроптоз'
];
  
export const userDiseasesConfirmed = [3, 6, 7, 9, 12, 13, 14, 19, 20, 28];

export const clientCourseFull = 1;
export const clientCoursePart = 2;
export const clientCourseWeek = 3;

// courses
export const courses = [
  { key: clientCourseFull, text: 'Полная стоимость', value: clientCourseFull },
  { key: clientCoursePart, text: 'Рассрочка', value: clientCoursePart },
  { key: clientCourseWeek, text: 'Неделя', value: clientCourseWeek }
];

export const smiles = ['😀', '😃', '😄', '😆', '😅', '😂', '🤣', '😊', '😇', '🙂', '🙃', '😉', '😌', '😍', '😗', '😙', '😚', '😋', '😛', '❤',
  '👍', '🙌', '👏', '🤝', '👇', '👆', '💪', '✍', '🍅', '👍', '💋', '❤', '💕', '💞', '💛', '💚', '💙', '💜', '💖', '🥰', '😻', '💝',
  '😍', '♥️', '💋', '❄️', '☃️', '🌲', '🌟', '🌸', '🌼', '🌻', '🌺', '🥀', '💐', '🌹', '🌷', '💃', '💞', '🍅', '🍆', '🥒', '🥕', '🥔', '🥗', '🧀'];
export const templates = ['Добрый день, [name]!', 'Здравствуйте, [name]!'];
export const reminders = [
  { key: 3600, text: '1 час', value: 3600 },
  { key: 10800, text: '3 часа', value: 10800 },
  { key: 28800, text: '8 часов', value: 28800 },
  { key: 86400, text: '24 часа', value: 86400 },
];

export const months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];

export const coursePeriodsPsychologicalWeek = 0;
export const coursePeriodsDetox = 1;
export const coursePeriodsExpress = 2;
export const coursePeriodsMarathon = 3;
export const coursePeriodsBalance = 4;

export const coursePeriodsWeek1 = 1;
export const coursePeriodsWeek2 = 2;
export const coursePeriodsWeek3 = 3;
export const coursePeriodsWeek4 = 4;

export const coursePeriods = [
  {id: coursePeriodsPsychologicalWeek, title: 'Психологическая неделя', days: 7},
  {id: coursePeriodsDetox, title: 'Детокс', days: 7},
  {id: coursePeriodsExpress, title: 'Экспресс', days: 14},
  {id: coursePeriodsMarathon, title: 'Марафон', days: 28},
  {id: coursePeriodsBalance, title: 'Баланс', days: 28}
];

export const coursePeriodsWeek = [
    {id: coursePeriodsWeek1, title: '1-я неделя'},
    {id: coursePeriodsWeek2, title: '2-я неделя'},
    {id: coursePeriodsWeek3, title: '3-я неделя'},
    {id: coursePeriodsWeek4, title: '4-я неделя'}
];

export const msgTypeMessage = 1;
export const msgTypeNote = 2;

export const msgDirectionClientToUser = 1;
export const msgDirectionUserToClient = 2;
export const msgDirectionBotToClient = 3;
export const msgDirectionNoteToClient = 4;
export const msgDirectionSystemToUser = 5;
export const msgDirectionAiToUser = 6;

export const userStatusNA = 0;
export const userStatusActive = 1;
export const userStatusDayOff = 2;
export const userStatusFired = 3;

export const userStatuses = [
    { key: userStatusNA, text: 'Статус', value: userStatusNA },
    { key: userStatusActive, text: 'Активен', value: userStatusActive },
    { key: userStatusDayOff, text: 'На выходном', value: userStatusDayOff },
    { key: userStatusFired, text: 'Уволен', value: userStatusFired },
];

export const coursesUsersFilter = [
    { key: 0, text: 'Программа', value: 0 },
    { key: clientCourseFull, text: 'Полные программы', value: clientCourseFull },
    { key: clientCoursePart, text: 'Рассрочки', value: clientCoursePart },
    { key: clientCourseWeek, text: 'Week', value: clientCourseWeek }
];

export const menuOptionForControl = {
    1: ["Первый вариант ступени Детокс", "Второй вариант ступени Детокс"],
    2: ["Меню экспресс с ежедневными рецептами", "Меню для ступени Экспресс с минимальным временем приготовления"],
    3: ["Ежедневное меню с рецептами", "Самостоятельное составление формул"],
};

export const stageProgramName = {
    coursePeriodsPsychologicalWeek: "Психологическая неделя",
    coursePeriodsDetox: "Детокс",
    coursePeriodsExpress: "Экспресс",
    coursePeriodsMarathon: "Марафон",
    coursePeriodsBalance: "Баланс"
}

export const handlePrepareData = (data) => {
  if (data.status === 'ok' || data.status === 'OK') {
      return data;
  }
  if (data.errors && data.errors.length > 0) {
      throw new Error(data.errors[0]);
  }
  throw new Error('error_other');
}

export const handlePrepareDataItem = (data) => {
  if (data.status === 'ok' || data.status === 'OK') {
      return data.item;
  }
  if (data.errors && data.errors.length > 0) {
      throw new Error(data.errors[0]);
  }
  throw new Error('error_other');
}

// TODO: move titles to backend
export const modulesFull = {
  'Profile': 'Профиль пользователя',
  'Users': 'Список пользователей',
  'Users:UserInviteModal': 'Приглашение нового пользователя (админский модуль)',
  'User': 'Пользователь (админский модуль)',
  'Roles': 'Роли (админский модуль)',
  'Role': 'Роль (админский модуль)',
  'Permissions': 'Разрешения (админский модуль)',
  'Permission': 'Разрешение (админский модуль)',
  'RolePermission': 'Разрешения роли (админский модуль)',
  'Flows': 'Процессы',
  'Mailing': 'Рассылки',
  'Mailing:MailingEditModal': 'Редактирование рассылки',
  'GetcourseData': 'Пользователи GetCourse',
  'GetcourseDataItem': 'Страница пользователя GetCourse',
  'Clients': 'Клиенты',
  'ClientsAdmin': 'Клиенты - под ролью администратора',
  'Clients:ClientEditModal': 'Клиенты - Редактирование клиента',
  'Clients:ClientDatesEditModal': 'Клиенты - Редактирование дат',
  'Clients:ClientsCuratorModal': 'Клиенты - Кураторы',
  'Clients:ClientsCuratorOnPageModal': 'Клиенты - Кураторы на странице',
  'ShiftControl': 'Контроль смен',
  'ResponseTime': 'Время ответа',
  'Settings': 'Настройки администратора',
  'Chat': 'Чат',
  'MenuDropDown': 'Меню в списке чатов',
  'ChatAdmin': 'Чат - под ролью администратора',
  'ChatAdmin:ChatClient': 'Чат - Клиент (админский модуль)',
  'Chat:ChatClient': 'Чат - Клиент',
  'Chat:ChatListPeriod': 'Чат - Список периодов',
  'Chat:ChatListTab': 'Чат - Список табов',
  'Chat:ChatMessages': 'Чат - Сообщения',
  'Chat:ChatAddMessage': 'Чат - Добавить сообщение',
  'Chat:ChatAdd': 'Чат - Добавить',
  'Chat:ChatList': 'Чат - Список чатов',
  'Chat:ChatListItem': 'Чат - Один Чат',
  'Chat:ClientAge': 'Чат - Возраст',
  'Chat:ClientDiseases': 'Чат - Болезни',
  'Chat:ClientRecentDiets': 'Чат - Недавние диеты',
  'Chat:ClientRecentDiseases': 'Чат - Недавние болезни',
  'Chat:ClientWeight': 'Чат - Вес',
  'Chat:ChatClientControl': 'Чат - Контроль клиента',
  'Chat:ClientLink': 'Чат - Ссылка на клиента',
  'Chat:ReadyAnswersModal': 'Чат - Быстрые ответы',
  'Chat:ChatAnswered': 'Чат - Отметка сообщений как отвеченных',
  'Chat:ChatReadyAnswersModal': 'Чат - Управление быстрыми ответами',
  'Chat:ClientNote': 'Чат - Заметки о клиенте',
}

export const SETTING_TYPES = {
  DEFAULT: 1,
  EXTENDED: 2
};